import { clsx } from 'clsx'
import { useRef } from 'react'
import { Input } from '../../atoms'
import type { InputPropsType } from '../../atoms/Input'
import { inputWrapped, inputWrapper } from './index.css'

export const InputWrapper = <
  GType extends React.HTMLInputTypeAttribute = 'text',
>(
  props: InputPropsType<GType> & {
    classNameWrapped?: string
  },
) => {
  const { className, classNameWrapped, style, children, ...remainProps } = props
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div
      className={clsx(inputWrapper, className)}
      style={style}
      onClick={() => inputRef.current?.focus()}
    >
      <Input<GType>
        {...remainProps}
        className={clsx(inputWrapped, classNameWrapped)}
        ref={inputRef}
      />
      {children}
    </div>
  )
}
